import React, { useState, useEffect } from "react";
import { useStaticQuery, graphql } from "gatsby"
import { Container, Row, Col } from "react-bootstrap";
import Slider from "react-slick";
import $ from "jquery";

import {news_slider_count} from "../../common/constant"

//import {LatestNews} from "../../common/queries/common_use_query"
import CaseStudyCard from "gatsby-theme-starberry-lomondgroup/src/components/CaseStudy/CaseStudyCard";
import "gatsby-theme-starberry-lomondgroup/src/components/CaseStudy/CaseStudy.scss";


const CaseStudy = ({Module}) => {

    //const{loading, error, data} = LatestNews();

    const data = useStaticQuery(graphql`
      query CaseStudyQuery{
        glstrapi {

            newhomes:caseStudies(
                sort: "createdAt:DESC"
                where: {category: "new_homes"}
                publicationState: LIVE
                limit: 12
            ) {
                title
                short_description
                image {
                    url
                    alternativeText
                }
                slug
                id
                category
                createdAt
                ggfx_results {
                  id
                  content_type
                  transforms
                  src_import_url
                  src_cftle
                  field
                }
            }
            
            land:caseStudies(
                sort: "createdAt:DESC"
                where: {category: "new_homes"}
                publicationState: LIVE
                limit: 12
            ) {
                title
                short_description
                image {
                    url
                    alternativeText
                }
                slug
                id
                category
                createdAt
                ggfx_results {
                  id
                  content_type
                  transforms
                  src_import_url
                  src_cftle
                  field
                }
            }

            developers:caseStudies(
                sort: "createdAt:DESC"
                where: {category: "new_homes"}
                publicationState: LIVE
                limit: 12
            ) {
                title
                short_description
                image {
                    url
                    alternativeText
                }
                slug
                id
                category
                createdAt
                ggfx_results {
                  id
                  content_type
                  transforms
                  src_import_url
                  src_cftle
                  field
                }
            }

        }
    }`)

    var caseStudies = data.glstrapi?.newhomes;

    if(Module?.choose_case_study === "lands"){
        caseStudies = data.glstrapi?.land
    }
    if(Module?.choose_case_study === "developers"){
        caseStudies = data.glstrapi?.developers
    }


    var settings = {
        dots: false,
        arrows: true,
        infinite: false,
        speed: 500,
        slidesToShow: news_slider_count || 4,
        slidesToScroll: 1,
        mobileFirst: true,
        afterChange: (event) => {
            var activeDotEl = $('.news .slick-slider').find('.slick-dots').find('li.slick-active');
            if(activeDotEl.get(0)){
                activeDotEl.get(0).scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
            }
            
        },
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    arrows: true,
                    dots: false,
                    slidesToShow: 3,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 992,
                settings: {
                    arrows: false,
                    dots: true,
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 767,
                settings: {
                    arrows: false,
                    dots: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };
    const [icon, setIcon] = useState(false);

    //console.log("Module ==>", Module)

    return (
        <>
            <section className={`case_study ${Module?.case_study_bg} ${Module?.case_study_padd}`}>
                <Container>
                    <Row>
                        <Col>
                            <h2>{(Module?.title) ? Module.title : 'Case Studies'}</h2>

                            {caseStudies?.length > 0 && 
                                <Slider {...settings}>
                                    {caseStudies?.map((item, index) => (
                                        <CaseStudyCard key={index} item={item} />
                                    ))}
                                </Slider>
                            }
                        </Col>
                    </Row>
                </Container>
            </section>

        </>
    );
};
export default CaseStudy;